
<div>

  <div class="oroHub" align="center">
    <br />

    <p [innerHTML]="this.pageStatement | safeHTML"></p>    

    <br />

    <table class="oroAccordionTable">
      <tbody>
        <tr class="oroAccordionTableHeader">
          <td>
            <span class="btn btn-link float-left">Available States</span>
          </td>
        </tr>
        <tr>
          <td>
            <span class="float-left">Select the State you are interested in</span>
          </td>
        </tr>
        <tr>
          <select class="form-control" (change)="onChangeState($event)" autofocus title="Select state">
            <option disabled selected value="">Select State</option>
            <option *ngFor="let item of this.availableStates; index as idx" [value]="item.Id">
              {{item.Name}}
            </option>
          </select>
        </tr>
      </tbody>
    </table>

    <br/>

    <table class="oroAccordionTable">
      <tbody>
        <tr class="oroAccordionTableHeader">
          <td>
            <span class="btn btn-link float-left">Available Counties</span>
          </td>
        </tr>
        <tr [hidden]="this.activeId != 'panelTwo'">
          <td>
            <span class="float-left">Select the County you would like to request a document from</span>
          </td>
        </tr>
        <tr [hidden]="this.activeId != 'panelTwo'">
          <select id="counties" class="form-control" (change)="onChangeCounty($event)" autofocus title="Select county">
            <option disabled selected value="">Select County</option>
            <option *ngFor="let item of this.filteredCounties; index as idx" [value]="item.Id">
              {{item.Name}}
            </option>
          </select>
        </tr>
      </tbody>
    </table>
    <br />

    <div>
      <button class="btn btn-primary float-right" (click)="gotoSelectCounty()" [disabled]="this.isDisabled" title="Continue to selected county">Continue</button>

      <br />
    </div>

    <br />

  </div>
</div>
